import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import VerifiedIcon from "@mui/icons-material/Verified";
import masterCardIcon from '../../assets/images/mastercard.png';
import visaCardIcon from '../../assets/images/visaCard.png';
import upiIcon from '../../assets/images/upi.png'

const CourseHeader = ({ title, fees, batch }) => {
    return (
        <Paper
            sx={{
                padding: "20px",
                background: "#ffffff",
                textAlign: "center",
                borderRadius: "12px",
                boxShadow: "0px 6px 15px rgba(0,0,0,0.1)",
                maxWidth: "400px",
                mx: "auto",
            }}
        >
            <Typography variant="h6" fontWeight="bold" sx={{ color: "#222" }}>
                {title}
            </Typography>

            <Typography variant="h6" fontWeight="bold" sx={{ color: "green", mt: 1 }}>
                Fees: <span style={{ fontWeight: "bold" }}>{fees}</span>
            </Typography>

            {/* Batch Starting Label */}
            <Box
                sx={{
                    background: "red",
                    color: "white",
                    display: "inline-block",
                    padding: "5px 15px",
                    borderRadius: "15px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    mt: 1,
                }}
            >
                Batch Starting, {batch}
            </Box>

            <Typography variant="body1" sx={{ color: "#666", mt: 1 }}>
                Live Session Timing: <strong>8:00AM, IST</strong>
            </Typography>

            {/* Enroll Now Button */}
            <Button
                variant="contained"
                fullWidth
                sx={{
                    mt: 2,
                    background: "linear-gradient(135deg, #007bff, #0056b3)",
                    color: "white",
                    fontWeight: "bold",
                    padding: "10px",
                    borderRadius: "8px",
                    "&:hover": { background: "#0056b3", transform: "scale(1.05)" },
                }}
            >
                ENROLL NOW
            </Button>

            {/* Secure Transaction & Payment Icons */}
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 2, gap: 1 }}>
                <VerifiedIcon sx={{ color: "green" }} />
                <Typography variant="body2" sx={{ color: "#444", fontWeight: "500" }}>
                    Secure Transaction
                </Typography>
                <img src={visaCardIcon} alt="Visa Card" width="35" />
                <img src={masterCardIcon} alt="Master Card" width="35" />
                <img src={upiIcon} alt="UPI Pay" width="40" />
            </Box>
        </Paper>
    );
};

export default CourseHeader;
